import { computed } from '@vue/composition-api'
import store from '@/store/'

export default () => {
  const computedData = {
    // 文章状态
    ARTICLE_STATUS: computed(() => (
      store.state.label.data.ARTICLE_MANAGEMENT?.ARTICLE_STATUS
    )),
    // 优先级
    ARTICLE_PRIORITY_LEVEL: computed(() => (
      store.state.label.data.ARTICLE_MANAGEMENT?.ARTICLE_PRIORITY_LEVEL
    )),
    // 分类是否显示
    ARTICLE_TYPE_IS_SHOW: computed(() => (
      store.state.label.data.ARTICLE_MANAGEMENT?.ARTICLE_TYPE_IS_SHOW
    )),
    // 标签状态
    LABEL_STATUS: computed(() => (
      store.state.label.data.ARTICLE_MANAGEMENT?.LABEL_STATUS
    )),
    // 是否推荐
    ARTICLE_ISCOMMEND: computed(() => (
      store.state.label.data.ARTICLE_MANAGEMENT?.ARTICLE_ISCOMMEND
    )),
    // 是否置顶
    ARTICLE_IS_TOP: computed(() => (
      store.state.label.data.ARTICLE_MANAGEMENT?.ARTICLE_IS_TOP
    )),
    // 所属字段
    TEMPLATE_TYPE: computed(() => (
      store.state.label.data.TEMPLATE_MANAGEMENT?.TEMPLATE_TYPE
    )),

    // 是否置顶
    INTERVIEW_IS_TOP: computed(() => (
      store.state.label.data.INTERVIEW_MANAGEMENT?.INTERVIEW_IS_TOP
    )),
    // 平台关系
    INTERVIEW_RANK: computed(() => (
      store.state.label.data.INTERVIEW_MANAGEMENT?.INTERVIEW_RANK
    )),

    // 七牛域名
    QI_NIU_DOMAINS: computed(() => (
      store.state.label.data.QI_NIU_DOMAINS
    ))
  }

  function showName(type, id) {
    const item = computedData[type].value.filter(item => item.key === id)[0]
    return (item && item.value) || '--'
  }

  return {
    ...computedData,
    showName
  }
}
